import { XCircleIcon } from '@heroicons/react/20/solid';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import React from 'react';

export interface SearchInputProps {
  onChange: (value: string) => void;
  value?: string;
  className?: string;
  placeholder?: string;
  isClearable?: boolean;
  onFocus?: (e: EventTarget) => void;
}
export const SearchInput: React.FC<SearchInputProps> = props => {
  return (
    <div className="relative rounded-md shadow-sm">
      <input
        value={props.value}
        className="focus:border-fiona relative block w-full rounded-md border border-gray-300 bg-white px-3 py-1.5 pl-9 pr-10 text-gray-900 placeholder:text-gray-400 focus:shadow-[0_0_0_2px_theme(colors.fiona)] focus:outline-none sm:text-sm sm:leading-6"
        placeholder={props.placeholder ?? 'Search'}
        onChange={e => {
          props.onChange(e.target.value);
        }}
        onFocus={e => {
          if (props.onFocus) {
            props.onFocus(e.target);
          }
        }}
      />
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
      </div>
      {props.isClearable && props.value && props.value.length > 0 && (
        <button
          type="button"
          onClick={() => props.onChange('')}
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
          aria-label="Clear search"
        >
          <XCircleIcon className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};
